import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import './App.css';

function ConnectWalletButton({ onConnect }) {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const checkConnection = async () => {
      if (window.ethereum) {
        const web3Instance = new Web3(window.ethereum);
        const accounts = await web3Instance.eth.getAccounts();
        if (accounts.length > 0) {
          setIsConnected(true);
          onConnect(true);
        }
      }
    };
    checkConnection();

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length === 0) {
          disconnectWallet();
        } else {
          connectWallet();
        }
      });

      window.ethereum.on('disconnect', () => {
        disconnectWallet();
      });
    }

    return () => {
      if (window.ethereum && window.ethereum.removeListener) {
        window.ethereum.removeListener('accountsChanged', () => {});
        window.ethereum.removeListener('disconnect', () => {});
      }
    };
  }, [onConnect]);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        console.log('Wallet connected');
        setIsConnected(true);
        onConnect(true);
        window.location.reload();
      } catch (error) {
        console.error("Error connecting to MetaMask:", error);
        setIsConnected(false);
        onConnect(false);
      }
    } else {
      alert('Please install MetaMask to use this feature!');
      setIsConnected(false);
      onConnect(false);
    }
  };

  const disconnectWallet = () => {
    if (window.ethereum) {
      window.ethereum.request({ method: 'wallet_requestPermissions', params: [{ eth_accounts: {} }] });
    }
    setIsConnected(false);
    console.log('Wallet disconnected');
    onConnect(false);
    window.location.reload();
  };

  return (
    <button 
      onClick={isConnected ? disconnectWallet : connectWallet} 
      className={`connect-wallet-btn ${isConnected ? 'connected-button' : 'connect-button'}`}
    >
      {isConnected ? 'Wallet Connected' : 'Connect Wallet'}
    </button>
  );
}

export default ConnectWalletButton;

























